import { makeStyles } from '@material-ui/core';

import palette from '../../../theme/palette';

export default makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(4)
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  title: {
    color: palette.home.title,
    fontWeight: 600
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  tabs: {
    '& .MuiTabs-indicator': {
      backgroundColor: palette.primary.lighter
    },
    '& .MuiTab-root': {
      color: palette.common.grayTextDark,
      fontWeight: 600,
      textTransform: 'none'
    },
    '& .Mui-selected': {
      color: palette.primary.main
    }
  },
  search: {
    minWidth: theme.spacing(34)
  },
  resultCount: {
    marginBottom: theme.spacing(1),
    color: palette.common.grayTextDark,
    fontWeight: 600
  },
  table: {
    width: '100%',
    minHeight: theme.spacing(32),
    '& .MuiDataGrid-columnHeaders': {
      color: palette.primary.main,
      backgroundColor: palette.navbar.grayBackground
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 700
    },
    '& .MuiDataGrid-cell': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }
  },
  actions: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5)
  },
  actionButton: {
    color: palette.white,
    backgroundColor: palette.buttons.purple,
    textTransform: 'none',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: palette.primary.lighter
    },
    '&.Mui-disabled': {
      color: palette.white,
      backgroundColor: palette.common.grayAvatar
    }
  }
}));
